import {shallowRef,ref} from 'vue'
import {claimPopup,releasePopup,suspendPopupParents} from './popupDisplay'

// 仅供错误展示与字段定位，不接收保存/支付/重试请求。
export const operationDialog=shallowRef<any>(null)
export const operationDialogVisible=ref(false)
let context=()=>'',active:any,timer:ReturnType<typeof setTimeout>|undefined
const queue:any[]=[]
function pump(){
  if(active || !queue.length)return
  const job=queue[0]
  if(job.disposed || job.stamp!==context()){queue.shift();job.options.afterClose?.();pump();return}
  let restore:(()=>void)|undefined
  if(!claimPopup(job)){restore=suspendPopupParents(job,true);if(!restore){timer=setTimeout(pump,150);return}}
  queue.shift();active=job;job.restore=restore
  operationDialog.value=job.options;operationDialogVisible.value=true
}
export function installOperationDialogs(getContext:()=>string){context=getContext}
export function openOperationDialog(options:any){
  const job:any={options,stamp:context(),disposed:false,confirmed:false}
  queue.push(job);pump()
  return {destroy(){job.disposed=true;if(active===job)operationDialogVisible.value=false;else pump()}}
}
export function confirmOperationDialog(){if(active){active.confirmed=true;operationDialogVisible.value=false}}
export function finishOperationDialog(){
  const job=active;if(!job)return
  active=undefined;operationDialog.value=null;releasePopup(job);job.restore?.()
  try{if(job.confirmed && !job.disposed && job.stamp===context())job.options.onOk?.(()=>undefined)}
  finally{job.options.afterClose?.();if(timer)clearTimeout(timer);timer=setTimeout(pump,1200)}
}
